module.exports = __webpack_public_path__ + "img/banner_pdf.c735156b.png";